import clsx from 'clsx';
import { generateDynamicThemeToken } from '../../../ThemeProvider';
import { getDynamicThemeToken } from '../theme';
import { validType } from '../util';
import { buttonClasses } from '../style';
import { getZoomIconDefaultStyles } from '../../../Shared/zoomIcon';
export function getHomeButtonStyle(theme, props) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName: 'Button',
        theme,
        dynamicToken,
    });
    const getHomeButtonTypeCSS = (btnType) => {
        const type = btnType && validType(btnType) ? btnType : 'default';
        return {
            background: tk(token.homeButton.background[type].default),
            color: tk(token.homeButton.color[type].default),
            borderColor: tk(token.homeButton.borderColor[type].default),
            '&:hover': {
                background: tk(token.homeButton.background[type].hover),
                color: tk(token.homeButton.color[type].hover),
                borderColor: tk(token.homeButton.borderColor[type].hover),
            },
            '&:active': {
                background: tk(token.homeButton.background[type].active),
                color: tk(token.homeButton.color[type].active),
                borderColor: tk(token.homeButton.borderColor[type].active),
            },
        };
    };
    const getHomeButtonDisabledCSS = (btnType) => {
        const type = btnType && validType(btnType) ? btnType : 'default';
        const disabledCSS = {
            background: tk(token.homeButton.background.disabled[type].default),
            color: tk(token.homeButton.color.disabled[type].default),
            borderColor: tk(token.homeButton.borderColor.disabled[type].default),
            // fontWeight: tk(token.fontWeight[type]),
            '&:hover': {
                background: tk(token.homeButton.background.disabled[type].hover),
                color: tk(token.homeButton.color.disabled[type].hover),
                borderColor: tk(token.homeButton.borderColor.disabled[type].hover),
            },
            '&:active': {
                background: tk(token.homeButton.background.disabled[type].active),
                color: tk(token.homeButton.color.disabled[type].active),
                borderColor: tk(token.homeButton.borderColor.disabled[type].active),
            },
        };
        return disabledCSS;
    };
    const newRootStyle = {
        [`&.${buttonClasses.root}`]: {
            textTransform: 'none',
            // boxShadow: 'none',
            borderStyle: 'solid',
            borderWidth: 1,
            whiteSpace: 'nowrap',
            [`&.${buttonClasses.focusVisible}, &:focus-visible`]: {
                outline: `2px solid ${tk(token.focusBorderColor)}`,
                outlineOffset: '2px',
            },
            // homeButton variant style
            [`&.${buttonClasses.homeButton}`]: {
                height: tk(token.homeButton.height),
                minWidth: tk(token.homeButton.width),
                ...(!props?.fullWidth && { width: tk(token.homeButton.width) }),
                padding: 0,
                fontSize: tk(token.homeButton.fontSize),
                svg: {
                    fontSize: tk(token.homeButton.fontSize),
                },
                borderRadius: tk(token.homeButton.borderRadius),
                ...getHomeButtonTypeCSS('default'),
                // hide startIcon and endIcon
                [`.${buttonClasses.startIcon}, .${buttonClasses.endIcon}`]: {
                    display: 'none',
                },
                [`&.${buttonClasses.primary}`]: getHomeButtonTypeCSS('primary'),
                [`&.${buttonClasses.secondary}`]: getHomeButtonTypeCSS('secondary'),
                [`&.${buttonClasses.tertiary}`]: getHomeButtonTypeCSS('tertiary'),
                [`&.${buttonClasses.disabled}`]: {
                    cursor: 'not-allowed',
                    ...getHomeButtonDisabledCSS(),
                    [`&.${buttonClasses.primary}`]: getHomeButtonDisabledCSS('primary'),
                    [`&.${buttonClasses.secondary}`]: getHomeButtonDisabledCSS('secondary'),
                    [`&.${buttonClasses.tertiary}`]: getHomeButtonDisabledCSS('tertiary'),
                },
            },
            ...getZoomIconDefaultStyles(),
        },
    };
    return newRootStyle;
}
export function generateHomeButtonClassnames() {
    const nameList = [];
    nameList.push(buttonClasses.root);
    nameList.push(buttonClasses.homeButton);
    return clsx(nameList);
}
